export default __webpack_public_path__ + "static/media/zarya-barrier.a90a1f87.mp3";